// removed by extract-text-webpack-plugin
module.exports = {"actions":"image-cropper__actions__3h70q","image-operations":"image-cropper__image-operations__O0KCR","upload-button":"image-cropper__upload-button__sUYrf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/image-cropper.scss
// module id = 1712
// module chunks = 1